import React, { useState, useRef, useContext } from "react";
import { AuthContext } from "../context/AuthContext";
import "./CEO.css";
import MenuItems from "../menubar/MenuItems";
import MobileMenuBar from '../menubar/MobileMenuBar';
import UserDots from "../menubar/UserDots";
import playIcon from "../image/play.png";
import { useDispatch, useSelector } from "react-redux";
import { startTimer, stopTimer, resetTimer } from "../processvideo/timerSlice";
import { getMemoCreateUrl, getUserSessionUrl } from "../constants";
import axios from "axios";
import { styled } from "@mui/material/styles";
import Box from "@mui/material/Box";
import Paper from "@mui/material/Paper";
import Grid from "@mui/material/Grid";
import Logo from '../menubar/Logo'
import { useNavigate } from 'react-router-dom';
import useMediaQuery from "@mui/material/useMediaQuery";




const Item = styled(Paper)(({ theme }) => ({
    backgroundColor: theme.palette.mode === "dark" ? "#1A2027" : "#000",
    ...theme.typography.body2,
    padding: theme.spacing(1),
    textAlign: "center",
    color: theme.palette.text.secondary,
    marginBottom: theme.spacing(1),
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
}));

function CEO() {
    const { username, userid, token, logout } = useContext(AuthContext);
    const [currentVideo, setCurrentVideo] = useState(null);
    const dispatch = useDispatch();
    const startTime = useSelector((state) => state.timer.startTime);
    const [videoDuration, setVideoDuration] = useState(0);
    const videoRef = useRef(null);
    const [currentVideoName, setCurrentVideoName] = useState(null);
    const [currentModuleName, setCurrentModuleName] = useState(null);
    const navigate = useNavigate();
    const isMobile = useMediaQuery("(max-width:768px)");


    const handleVideoLoad = () => {
        if (videoRef.current) {
            setVideoDuration(videoRef.current.duration);
        }
    };

    const videoProcesses = [
        { name: "Message-CEO", video: "/choppies/assets/video/ceo/ceo_message.m4v", moduleName: "CEO" },
    ];

    const handlePlayClick = async (process) => {
        try {
            const response = await axios.get(getUserSessionUrl(userid), {
                headers: {
                    Authorization: `Bearer ${token}`,
                },
            });

            if (response.status === 200) {
                // ✅ If session is valid, proceed with opening PDF or playing video
                setCurrentVideo(process[0].video);
                setCurrentVideoName(process[0].name);
                setCurrentModuleName(process[0].moduleName);
                dispatch(startTimer());

            }

        } catch (error) {
            console.error('Session check error:', error);
            if (error.response && error.response.status === 403) {
                logout();
                navigate('/');
            }
        }
    };


    const handlePlayCloseClick = () => {
        if (startTime) {
            const watchTime = Math.round((Date.now() - startTime) / 1000);
            dispatch(stopTimer());
            axios.post(getMemoCreateUrl(), {
                userid,
                username,
                module: currentModuleName,
                name: currentVideoName,
                video: currentVideo,
                watchTime,
                duration: videoDuration,
            })
                .then(() => dispatch(resetTimer()))
                .catch((error) => {
                    console.error("Error storing watch time:", error);
                    if (error.response && error.response.status === 403) {
                        logout();
                        navigate('/');
                    }
                });
        }
        setCurrentVideo(null);
    };

    return (
        <Box className="app-container-ceo">
            <Grid container spacing={0} className="ceo-grid">
                <Grid item xs={12} md={6} container direction="column" style={{ minHeight: "50vh" }}>
                    {/* Logo Section (30%) */}
                 
                {isMobile ? (
                <div style={{ width: '100%', display: 'flex', justifyContent: 'center', marginTop: '20px' }}>
                    <MobileMenuBar />
                </div>
            ) : (
                <>
                    <Logo />
                    <UserDots />
                    <Grid item style={{ flex: "0 0 25%", display: "flex", flexDirection: "column", alignItems: "center", justifyContent: "center" }}>
                        <div className="p-menu-section">
                            <MenuItems />
                        </div>
                    </Grid>
                </>
            )}

                    <Grid
                        item
                        style={{
                            flex: "1", /* Takes remaining height (70%) */
                            backgroundImage: `url('/choppies/assets/ceo.png')`,
                            backgroundSize: "cover",
                            backgroundPosition: "top 20% center", /* Moves background image slightly down */
                            paddingTop: "2%",  /* Increases top padding for more space */
                            display: "flex",
                            cursor: "pointer",
                            alignItems: "flex-start", /* Aligns content to the top */
                            justifyContent: "flex-start", /* Aligns content to the left */
                            paddingLeft: "2%" /* Adds a little left padding */
                        }}
                        onClick={() => handlePlayClick(videoProcesses)}
                    >

                    </Grid>


                </Grid>

                {!isMobile ? (
                    <Grid item xs={12} md={6} container direction="column" style={{ minHeight: "50vh" }}>
                        <Item style={{ height: "33%" }}>

                        </Item>

                        <Item style={{ height: "33%", justifyContent: "flex-end", textAlign: "right", paddingRight: "5%" }}>
                            <blockquote className="leader-quote">
                                <span className="quote-mark">“</span>
                                A good leader can engage in a debate frankly and thoroughly, knowing that at the end he and the other side must be closer, and thus emerge stronger. You don't have that idea when you are arrogant, superficial, and uninformed.
                                <span className="quote-mark">”</span>
                                <br />
                                <span className="quote-author">— Nelson Mandela</span>
                            </blockquote>
                        </Item>

                        <Item style={{ justifyContent: "flex-start", textAlign: "left", paddingTop: "20%" }}>
                            <div className="play-section">
                                <button className="play-button" onClick={() => handlePlayClick(videoProcesses)}>
                                    <img src={playIcon} alt="Play" className="play-icon" />
                                </button>
                                <span className="ceo-name">Ramachandran Ottapathu <span className="ceo-title">- CEO</span></span>
                            </div>
                        </Item>
                    </Grid>
                ) : (
                    <Grid item xs={12} md={6} container direction="column" justifyContent="space-between" style={{ padding: "0px" }}>
                        <Item style={{ textAlign: "left", marginTop: "0px" }}>
                            <div className="play-section">
                                <button className="play-button" onClick={() => handlePlayClick(videoProcesses)}>
                                    <img src={playIcon} alt="Play" className="play-icon" />
                                </button>
                                <span className="ceo-name">Ramachandran Ottapathu <span className="ceo-title">- CEO</span></span>
                            </div>
                        </Item>
                        <Item style={{ textAlign: "right", marginTop: "auto" }}>
                            <blockquote className="leader-quote">
                                <span className="quote-mark">“</span>
                                A good leader can engage in a debate frankly and thoroughly, knowing that at the end he and the other side must be closer, and thus emerge stronger. You don't have that idea when you are arrogant, superficial, and uninformed.
                                <span className="quote-mark">”</span>
                                <br />
                                <span className="quote-author">— Nelson Mandela</span>
                            </blockquote>
                        </Item>
                    </Grid>
                )}
            </Grid>
            {currentVideo && (
                <div className={isMobile ? "video-overlay-mobile" : "video-overlay"}>
                    <video className="video-player" controls autoPlay src={currentVideo} ref={videoRef} onLoadedMetadata={handleVideoLoad} />
                    <button className="close-button" onClick={handlePlayCloseClick}>✖</button>
                </div>
            )}
        </Box>
    );
}

export default CEO;